<template>
  <div class="produto-cdlsaude-cadastrofinal">
    <section class="termo-aceite" v-if="termoAceite">
      <h4 class="h4 color-blue font-weight-bold">Aceite do Termo Aditivo</h4>
      <Aceite
        :voltar="voltar"
        :link-voltar="`trocaracomodacao/${this.acomodacao.codVida}`"
        :action-aceite="true"
        @click="salvarAceite"
        :file="file"
        :aceite="aceite"
        :loading="loading"
        :strLoading="'Aguarde, salvando o termo'"
      />
    </section>
    <section v-else>
      <div class="content">
        <div class="row mb-3">
          <div class="col-md-6">
            <Titulo
              title="Pagamento"
              description="Efetue o pagamento da troca de acomodação."
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <Carrinho :title="'Informações do Plano'" :list="lista" />
          </div>
          <div class="col-md-6 mt-3 mt-md-0">
            <FormasPagamento
              :formasPagamento="formasPagamento"
              :validarAceite="false"
              :loading="loading"
              @method="efetuarpagamento"
            />
          </div>
        </div>
      </div>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            :link="`trocaracomodacao/${acomodacao.codVida}`"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
      </div>
    </section>
    <div class="py-5"></div>
  </div>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Carrinho from "@/components/pagamento/Carrinho";
import FormasPagamento from "@/components/pagamento/MetodosPagamento";
import Aceite from "@/components/aceite/Aceite.vue";
//import { clearStr } from "../../../helpers";
export default {
  name: "ListaVidas",
  components: { Titulo, Botao, Carrinho, FormasPagamento, Aceite },
  data() {
    return {
      produto: {
        nome: "CDL Saúde",
        id: "SPC Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Pagamento",
          id: "pagamento",
        },
      ],
      lista: [],
      acomodacao: {
        codVida: null,
      },
      formasPagamento: {
        cartaocredito: true,
        boleto: {
          status: true,
          msg: "",
        },
      },
      loading: false,
      termoAceite: true,
      checkAceite: false,
      voltar: true,
      aceite: "Estou de acordo com o termo acima.",
      file: null,
      cpfTitular: null,
    };
  },
  methods: {
    async montarDados() {
      const dadosVida = JSON.parse(sessionStorage.getItem("trocaAcomodacao"));
      this.cpfTitular = dadosVida.listaVidas[0].cpF_TITULAR;
      this.total = dadosVida.total;

      const vidaTitular = await dadosVida.listaVidas.filter(
        (el) => el.cpF_DEPENDENTE === ""
      );

      this.$http
        .get(
          `api/Drive/BuscarTermoTrocaAcomodacao?codVida=${vidaTitular[0].codVida}`
        )
        .then((response) => {
          this.file = `data:application/pdf; base64, ${response.data.file.fileContents}`;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });

      const descricaoCarrinho = {
        desc: `Troca de acomodação de ${dadosVida.listaVidas[0].acomodacao}
          para ${
            dadosVida.listaVidas[0].acomodacao === "APARTAMENTO"
              ? "ENFERMARIA"
              : "APARTAMENTO"
          }`,
        info: `Titular ${
          dadosVida.listaVidas[0].dependentes.length
            ? ", " + dadosVida.listaVidas[0].dependentes.length + " dependentes"
            : ""
        }`,
        value: dadosVida.total,
      };

      this.lista.push(descricaoCarrinho);
      this.acomodacao = dadosVida.trocaAcomodacao;
      this.acomodacao.codVida = vidaTitular[0].codVida;
    },
    async efetuarpagamento(payload) {
      this.loading = true;
      if (payload.type === "Boleto") {
        const acomodacao = this.acomodacao;
        this.$http
          .post("/api/GestaoSaude/RegistrarBoletoTrocaAcomodacao", {
            ...acomodacao,
          })
          .then((response) => {
            if (response.data.sucesso) {
              sessionStorage.removeItem("trocaAcomodacao");
              this.$toast.open({
                message:
                  "Boleto gerado com sucesso! Redirecionando para a lista de vidas...",
                type: "success",
              });
              setTimeout(() => {
                this.$router.push({
                  name: "listavidas",
                });
              }, 2000);
              window.open(response.data.urlBoleto);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$toast.open({
              message: error.response.data.mensagem,
              type: "warning",
            });
          });
      } else if (payload.type === "Cartao") {
        const dadosCartao = payload.payload.dataCard;
        const acomodacao = this.acomodacao;
        this.$http
          .post("/api/GestaoSaude/PagamentoCreditoTrocaAcomodacao", {
            nomeCartao: dadosCartao.nomeCartao,
            numeroCartao: dadosCartao.numeroCartao,
            dataExpiracaoCartao: dadosCartao.dataExpiracaoCartao,
            codigoValidacaoCartao: dadosCartao.codigoValidacaoCartao,
            trocaAcomodacao: { ...acomodacao },
          })
          .then((response) => {
            if (response.data.sucesso) {
              sessionStorage.removeItem("trocaAcomodacao");
              this.$toast.open({
                message:
                  "Pagamento finalizado com sucesso! Redirecionando para a lista de vidas...",
                type: "success",
              });
              this.loading = false;
              setTimeout(() => {
                this.$router.push({
                  name: "listavidas",
                });
              }, 2000);
            } else {
              this.loading = false;
              this.$toast.open({
                message:
                  "Erro ao processar seu pagamento, verifique os dados do cartão e tente novamente.",
                type: "warning",
              });
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$toast.open({
              message: error.message,
              type: "warning",
            });
          });
      }
    },
    salvarAceite(payload) {
      this.checkAceite = payload.checkAceite;
      this.enviarAceite();
    },
    async enviarAceite() {
      this.loading = true;
      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }
      await this.$http
        .post(`/api/Drive/AceitarTermoTrocaAcomodacao`, {
          dtVersao: new Date(),
          dtAceite: new Date(),
          ipOrigem: sessionStorage.ip,
          browserData: navigator.appVersion,
          cpfTitular: this.cpfTitular,
        })
        .then((response) => {
          if (response.status == 200) {
            this.loading = false;
            this.termoAceite = false;
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toast.open({
            message: "Erro no envio dos seus arquivos, tente novamente.",
            type: "error",
          });
          this.loading = false;
        });
    },
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.montarDados();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_mixins.scss";
@import "@/assets/scss/_vars.scss";
.produto-cdlsaude-cadastrofinal /deep/ {
  @import "@/assets/scss/_vue-formulate.scss";
  .formulate-input {
    margin-top: 1rem;
    .formulate-input-wrapper {
    }
    .formulate-input-label {
      margin-bottom: 0.5rem;
    }

    .formulate-input-element {
      padding: 5px;
      background: $dark-100;
      input,
      select {
        background: $dark-100;
      }
    }
    &[data-classification="select"] {
      select {
        width: 100%;
      }
    }
    &[data-classification="button"] {
      &,
      .formulate-input-element {
        padding: 0;
        background-color: transparent;
      }
    }
  }
}
.label {
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 3px;
  text-transform: capitalize;
}
.value {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
